import { render, staticRenderFns } from "./lawService.vue?vue&type=template&id=7c313a15&scoped=true&"
import script from "./lawService.vue?vue&type=script&lang=js&"
export * from "./lawService.vue?vue&type=script&lang=js&"
import style0 from "./lawService.vue?vue&type=style&index=0&id=7c313a15&prod&lang=less&"
import style1 from "./lawService.vue?vue&type=style&index=1&id=7c313a15&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c313a15",
  null
  
)

export default component.exports